import React from 'react';

interface IProps {
  children: React.ReactNode,
  className?: string,
  dataTest?: string,
}

const TabList = ({ children, className, dataTest = 'tabList' }: IProps) => (
  <div
    role="tablist"
    data-test={ dataTest }
    className={ className }
  >
    { children }
  </div>
);

export default TabList;
